






























































































import CompanySheet from "@/components/company/CompanySheet.vue";
import PreselectTemplateCard from "@/components/partner/PreselectTemplateCard.vue";
import MNoContent from "@/components/utility/mmmint/MNoContent.vue";
import { PreselectTemplateKeysEnum } from "@/lib/enum/preselect-template-keys.enum";
import { RequestStatusEnum } from "@/lib/enum/request-status-enum";
import { IDialog } from "@/lib/interfaces/dialog.interface";
import { handleError } from "@/lib/utility/handleError";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { Appraisal, IAppraisal } from "@/models/appraisal.entity";
import { Reference } from "@/models/reference.entity";
import { ISharedContent, SharedContent } from "@/models/shared-content.entity";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { UserModule } from "@/store/modules/me-user.store";
import { PartnerModule } from "@/store/modules/partner";
import { mixins } from "vue-class-component";
import { Component, Prop, Ref, Watch } from "vue-property-decorator";

export enum AppraisalRequestSteps {
  FORM = "form",
  SEND_MAIL = "sendMail"
}

@Component({
  components: { PreselectTemplateCard, CompanySheet, MNoContent },
  filters: {}
})
export default class ReportAppraisalRequestDialog extends mixins(PermissionMixin) implements IDialog {
  readonly AppraisalRequestSteps = AppraisalRequestSteps;
  readonly PreselectTemplateKeysEnum = PreselectTemplateKeysEnum;

  @Ref("templateCard")
  templateCard!: PreselectTemplateCard;

  @Prop({ default: false }) value!: boolean;

  dialog: boolean = this.value;

  @Watch("value")
  onValueChange(val: boolean) {
    if (val) {
      this.appraisalRequest.dateFormable = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toString();
    }
    this.dialog = val;
  }

  @Watch("dialog")
  onDialogChange(val: boolean) {
    this.$emit("input", val);
  }

  step = AppraisalRequestSteps.FORM;
  appraisalRequest: IAppraisal = new Appraisal({}).setDefaultLineItems();
  sharedContent: ISharedContent = new SharedContent({ partnerId: this.partner.id });

  requestsLoading = false;

  get partner() {
    return PartnerModule.partner;
  }

  get report() {
    return PartnerModule.report;
  }

  get context() {
    return {
      appraisal: this.appraisalRequest,
      sharedContent: this.sharedContent,
      partner: this.partner,
      report: this.report,
      url: { sharing: this.sharedContent.url }
    };
  }

  get validForm() {
    return this.appraisalRequest.dateFormable && this.report.appraiserCompanyId;
  }

  get myUserId() {
    return UserModule.userId;
  }

  async createRequests() {
    this.requestsLoading = true;
    if (this.appraisalRequest.id) {
      throw new Error("Appraisal request ID is already defined");
    }

    if (!this.report.appraiserCompanyId) {
      throw new Error("Appraiser company ID is not defined in the report");
    }

    if (!this.report.appraiserCompany) {
      await this.report.fetchAppraiserEntity();
    }

    if (!this.report.appraiserCompany) {
      throw new Error("Error loading appraiser entity");
    }

    try {
      this.appraisalRequest.seller = this.report.appraiserCompany.invoiceParty;

      this.appraisalRequest.refs = [];

      if (this.myUserId) {
        this.appraisalRequest.assignees = [this.myUserId];
      }

      this.appraisalRequest.refs.push(new Reference({ refId: this.report.id, refType: ResourceEnum.REPORT }));

      if (this.report.vehicleId) {
        this.appraisalRequest.refs.push(new Reference({ refId: this.report.vehicleId, refType: ResourceEnum.VEHICLE }));
      }

      this.appraisalRequest.partnerId = this.report.partnerId;
      this.appraisalRequest.reportId = this.report.id;

      await this.appraisalRequest.create();

      if (this.report.appraiserCompany.activeSharedContent) {
        this.report.appraiserCompany.activeSharedContent.addRef(
          new Reference({ refId: this.appraisalRequest.id, refType: ResourceEnum.APPRAISAL }),
          true
        );
        this.sharedContent = this.report.appraiserCompany.activeSharedContent;
      } else {
        this.sharedContent.reportId = this.report.id;
        this.sharedContent.companyIds = [this.report.appraiserCompanyId];
        this.sharedContent.refs = this.appraisalRequest.refs;

        if (this.appraisalRequest.id) {
          this.sharedContent.refs.unshift(
            new Reference({ refId: this.appraisalRequest.id, refType: ResourceEnum.APPRAISAL })
          );
        } else {
          throw new Error("Appraisal request ID is not defined");
        }

        await this.sharedContent.create();
        this.report.appraiserCompany.activeSharedContent = this.sharedContent;
        this.report.appraiserCompany.sharedContent.push(this.sharedContent);
      }
      this.appraisalRequest.sharedContent.push(this.sharedContent);
      this.report.appraisals.unshift(this.appraisalRequest);

      this.$emit("create:sharedContent", this.sharedContent);
    } catch (e) {
      handleError(e);
    }
    this.requestsLoading = false;
    return {
      appraisal: this.appraisalRequest,
      sharedContent: this.sharedContent
    };
  }

  async createAndClose() {
    const request = await this.createRequests();
    request.sharedContent.copyUrl();
    this.close();
  }

  async createReportAndSend() {
    await this.createRequests();
    this.step = AppraisalRequestSteps.SEND_MAIL;
  }

  async sendMail() {
    await this.templateCard?.send();
    await this.appraisalRequest.updatePartial({
      status: RequestStatusEnum.REQUESTED
    });
    await this.appraisalRequest.updateStatusLog();
    this.close();
  }

  async close() {
    this.dialog = false;
    this.reset();
  }

  open() {
    this.reset();
    this.dialog = true;
  }

  reset() {
    this.step = AppraisalRequestSteps.FORM;
    this.appraisalRequest = new Appraisal({ partnerId: this.partner.id }).setDefaultLineItems();
    this.sharedContent = new SharedContent({ partnerId: this.partner.id });
  }
}
